/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：815
 */

module.exports = {
  IconLibraryItem: "style_IconLibraryItem__1pnTx",
  selected: "style_selected__svnYm",
  icon: "style_icon__1b_IQ",
  content: "style_content__3G9eC",
  footer: "style_footer__1rK5w"
}
